import Loader from 'react-loaders'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAppleAlt, faDog, faShoppingBasket } from '@fortawesome/free-solid-svg-icons'

const Contact = () => {
  const [letterClass, setletterClass] = useState('text-animate')
  const refForm = useRef()

  useEffect(() => {
    setTimeout(() => {
      setletterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_7vcixwl',
        'template_368p6df',
        refForm.current,
        'IWvUF_NAp5tb3wEFo'
      )
      .then(
        () => {
          alert('Message sent successfully!')

          window.location.reload(false)
        },
        () => {
          alert('Failed to send the message, Try again!')
        }
      )
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                'G',
                'e',
                't',
                ' ',
                'i',
                'n',
                ' ',
                't',
                'o',
                'u',
                'c',
                'h',
              ]}
              idx={15}
            />
          </h1>
          <p>
            Is there something on your mind you'd like to talk about? Whether
            it's related to work or just a casual conversation, I am here and
            ready to listen.
          </p>
          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input type="text" name="name" placeholder="Name" required />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea placeholder="Message" name="message" required />
                </li>
                <li>
                  <input type="submit" className="flat-button" value="Send" />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Rudra Vashishtha
          <br />
          India
          <br />
          <span>
            <a href="mailto:rudraturtle7@gmail.com">rudraturtle7@gmail.com</a>
          </span>
          <Link
            to="https://drive.google.com/file/d/1llD5A-iErRBg7utyy8WPgN8RucP8Cgxi/view?usp=sharing"
            className="flat-button"
            target="_blank"
            rel="noreferrer"
          >
            DOWNLOAD RESUME
          </Link>
        </div>
        <div className="projects">
          <h1>Projects</h1>
          <div className="project">
            <FontAwesomeIcon icon={faShoppingBasket} className="icon" />
            <h3>E- Commerce (Next.js)</h3>
            <button className="visit-button">
              <a
                href="https://nextjs-ecommerce-rudra.vercel.app"
                target="_blank"
                rel="noreferrer"
              >
                Visit
              </a>
            </button>
          </div>
          <div className="project">
            <FontAwesomeIcon icon={faAppleAlt} className="icon" />
            <h3>Apple Animated Website</h3>
            <button className="visit-button">
              <a
                href="https://r-apple-website.netlify.app"
                target="_blank"
                rel="noreferrer"
              >
                Visit
              </a>
            </button>
          </div>
          <div className="project">
            <FontAwesomeIcon icon={faDog} className="icon" />
            <h3>Tinder for Dogs Clone</h3>
            <button className="visit-button">
              <a
                href="https://tindog-rudra.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                Visit
              </a>
            </button>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
